import styled, { css } from "styled-components";
import { mediaQuery, transition, colors } from "oolib";

const { greyColor15, greyColor80, greyColor70, greyColor40, none } = colors;

export const StyledSliderWrapper = styled.div`
  flex-shrink: 1;
  display: flex;
  gap: 1rem;
  overflow-x: auto;
`;

export const thumbnailBaseCss = css`
  background-color: ${({ invert, theme }) =>
    invert ? theme?.colors?.primaryColor40 : theme?.colors?.primaryColor100};
  cursor: ${({ isLoading }) => (isLoading ? "initial" : "pointer")};
  width: 6rem;
  height: 6rem;
  flex-shrink: 0;

  ${mediaQuery("sm")} {
    width: 9rem;
    height: 9rem;
  }

  ${transition("background-color")};
`;

export const StyledAddMoreThumbnail = styled.div`
  ${thumbnailBaseCss};
  flex-shrink: 0;
  @media (hover: hover) {
    &:hover {
      background-color: ${({ invert, theme }) =>
        invert ? theme?.colors?.primaryColor10 : theme?.colors?.primaryColor40};
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ invert }) => (invert ? greyColor70 : greyColor15)};
      color: ${greyColor40};
      pointer-events: none;
    `}
`;
export const StyledImageThumbnail = styled.div`
  ${thumbnailBaseCss};
  position: relative;
  overflow: hidden;
  ${({ theme, isActive, invert }) => css`
    border: 2px solid ${
      isActive
        ? invert
          ? theme?.colors?.primaryColor40
          : theme?.colors?.primaryColor100
        : invert
        ? greyColor80
        : greyColor15
    }};
  `}
`;

export const StyledPlaceholderThumbnail = styled.div`
  ${thumbnailBaseCss};
  background-color: ${none};
  border: 2px solid ${({ theme }) => theme?.colors?.primaryColor10};
`;
